import { FC, useMemo } from "react";
import {
  IVDPBlockData,
  IVDPPageBlock,
  VDPBlockPageData,
  VDPBlockPosition,
  VDPComponentServerHook,
} from "../../../types/vdp";
import Gallery from "./gallery";
import { useIsMobile } from "../../../utils/useIsMobile";
import { Vehicle } from "../../../types/vehicle";
import { CustomGalleriaItem } from "../../../types/site";

export interface CustomGalleriaItemTab {
  title: string;
  iframeUrl: string;
}

interface IVDPGallery {
  customGalleriaItemTabs: CustomGalleriaItemTab[];
}

const VDPGallery: FC<IVDPPageBlock> = ({ config, siteData, vdpGlobalData, pageContext, translations }) => {
  const isMobile = useIsMobile(undefined, pageContext.isSmartphone);

  const galleryConfig: IVDPGallery = config;
  const dealerPhoto =
    siteData?.noImagesPhoto === "" || siteData?.noImagesPhoto === undefined
      ? ""
      : siteData?.baseUrl + siteData?.noImagesPhoto;

  const vehicle = vdpGlobalData.vehicle;
  const mainImages = useMemo(() => {
    return (isMobile ? vehicle.photosMedium : vehicle.photos) || vehicle.photos || [];
  }, [vehicle.photos, vehicle.photosMedium, isMobile]);
  const smallImages = vehicle.photosSmall || vehicle.photosMedium || vehicle.photos || [];

  return (
    <Gallery
      images={mainImages}
      smallImages={smallImages}
      dealerPhoto={dealerPhoto}
      currentVehicle={vehicle}
      customGalleriaItemTabs={galleryConfig?.customGalleriaItemTabs}
      translations={translations}
      vdpGlobalData={vdpGlobalData}
      isSmartphone={pageContext.isSmartphone}
    />
  );
};

interface IVDPGalleryConfig {
  customTabs: CustomGalleriaItem[];
}

export const VdpGalleryServerSideHook: VDPComponentServerHook = async (
  config: any,
  vehicle: Vehicle,
  pageData: VDPBlockPageData,
) => {
  const galleryConfig: IVDPGalleryConfig = config;
  const componentConfig: IVDPGallery = { customGalleriaItemTabs: [] };
  for (let i = 0; i < galleryConfig?.customTabs?.length; i++) {
    const customGalleriaItem = galleryConfig?.customTabs[i];
    let searchQueryParamsString: string = "";
    customGalleriaItem.vehicleParams.forEach((param) => {
      if (searchQueryParamsString) {
        searchQueryParamsString += "&";
      }
      searchQueryParamsString += `${param}=${(vehicle as any)[param]}`;
    });

    customGalleriaItem.otherParams?.forEach((param) => {
      if (searchQueryParamsString) {
        searchQueryParamsString += "&";
      }
      searchQueryParamsString += `${param.name}=${param.value}`;
    });

    const fullcustomItemUrlResolver = searchQueryParamsString
      ? `${customGalleriaItem.resolverUrl}?${searchQueryParamsString}`
      : customGalleriaItem.resolverUrl;
    const iframeUrlResponse = await fetch(fullcustomItemUrlResolver, { headers: { Origin: pageData.host } });
    if (iframeUrlResponse.status === 200) {
      const iframeUrl = await iframeUrlResponse.text();
      if (iframeUrl && iframeUrl !== "null") {
        componentConfig.customGalleriaItemTabs.push({ title: customGalleriaItem.title, iframeUrl });
      }
    } else {
      console.error("could not get iframe for tab", fullcustomItemUrlResolver);
    }
  }

  return componentConfig;
};

const VDPBlockData: IVDPBlockData = {
  component: (props: IVDPPageBlock, key: any) => (
    <VDPGallery
      key={key}
      config={props.config}
      siteData={props.siteData}
      pageContext={props.pageContext}
      renderingPosition={props.renderingPosition}
      vdpGlobalData={props.vdpGlobalData}
      translations={props.translations}
    />
  ),
  position: VDPBlockPosition.LEFT,
};

export default VDPBlockData;
